/** @jsx jsx */
import { jsx } from '@emotion/react'
import { googleStyle } from '../assets/styles/GooglePlayStoreIcon.styles'

const GooglePlayStoreIcon = () => {
  return (
    <a href='https://play.google.com/store/apps/details?id=br.com.fractaltecnologia.adaptativo'>
      <svg
        css={googleStyle}
        width='176'
        height='52'
        viewBox='0 0 176 52'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          className='googleBG'
          d='M169.481 0H6.51852C2.91844 0 0 2.91015 0 6.5V45.5C0 49.0898 2.91844 52 6.51852 52H169.481C173.082 52 176 49.0898 176 45.5V6.5C176 2.91015 173.082 0 169.481 0Z'
          fill='#F9F9F9'
        />
        <path
          d='M88.8349 28.2749C85.7712 28.2749 83.2681 30.6019 83.2681 33.7999C83.2681 36.9979 85.7712 39.3249 88.8349 39.3249C91.8986 39.3249 94.4017 36.9849 94.4017 33.7999C94.4017 30.6149 91.8986 28.2749 88.8349 28.2749ZM88.8349 37.1539C87.1531 37.1539 85.706 35.7759 85.706 33.7999C85.706 31.8239 87.1531 30.4459 88.8349 30.4459C90.5167 30.4459 91.9638 31.8109 91.9638 33.7999C91.9638 35.7889 90.5167 37.1539 88.8349 37.1539ZM76.6974 28.2749C73.6337 28.2749 71.1306 30.6019 71.1306 33.7999C71.1306 36.9979 73.6337 39.3249 76.6974 39.3249C79.7611 39.3249 82.2642 36.9849 82.2642 33.7999C82.2642 30.6149 79.7611 28.2749 76.6974 28.2749ZM76.6974 37.1539C75.0157 37.1539 73.5685 35.7759 73.5685 33.7999C73.5685 31.8239 75.0157 30.4459 76.6974 30.4459C78.3792 30.4459 79.8263 31.8109 79.8263 33.7999C79.8263 35.7889 78.3792 37.1539 76.6974 37.1539ZM62.2524 29.9649V32.3049H67.8844C67.7149 33.6309 67.2717 34.5929 66.6068 35.2559C65.7854 36.0749 64.5078 36.9719 62.2654 36.9719C58.7976 36.9719 56.0859 34.1899 56.0859 30.7319C56.0859 27.2739 58.7976 24.4919 62.2654 24.4919C64.1297 24.4919 65.4986 25.2199 66.5025 26.1689L68.1582 24.5179C66.7502 23.1789 64.8859 22.1519 62.2524 22.1519C57.5069 22.1519 53.5176 25.9999 53.5176 30.7449C53.5176 35.4899 57.5069 39.3379 62.2524 39.3379C64.8207 39.3379 66.7502 38.5059 68.2625 36.9329C69.8139 35.3859 70.2962 33.2019 70.2962 31.4469C70.2962 30.9009 70.2571 30.3939 70.1659 29.9779H62.2524V29.9649ZM121.323 31.7849C120.867 30.5499 119.459 28.2619 116.578 28.2619C113.697 28.2619 111.35 30.4979 111.35 33.7869C111.35 36.8809 113.697 39.3119 116.852 39.3119C119.394 39.3119 120.867 37.7649 121.467 36.8679L119.576 35.6069C118.95 36.5299 118.09 37.1409 116.852 37.1409C115.613 37.1409 114.726 36.5689 114.166 35.4639L121.584 32.4089L121.336 31.7849H121.323ZM113.762 33.6309C113.697 31.4989 115.417 30.4069 116.656 30.4069C117.621 30.4069 118.442 30.8879 118.716 31.5769L113.762 33.6309ZM107.739 38.9869H110.177V22.7369H107.739V38.9869ZM103.749 29.4969H103.671C103.124 28.8469 102.081 28.2619 100.751 28.2619C97.9739 28.2619 95.4316 30.6929 95.4316 33.8129C95.4316 36.9329 97.9739 39.3249 100.751 39.3249C102.081 39.3249 103.124 38.7399 103.671 38.0639H103.749V38.8569C103.749 40.9759 102.615 42.1069 100.79 42.1069C99.3036 42.1069 98.378 41.0409 97.9999 40.1439L95.8749 41.0279C96.4877 42.4969 98.1042 44.2909 100.79 44.2909C103.645 44.2909 106.057 42.6139 106.057 38.5319V28.5999H103.749V29.4969ZM100.959 37.1409C99.2776 37.1409 97.8696 35.7369 97.8696 33.8129C97.8696 31.8889 99.2776 30.4459 100.959 30.4459C102.641 30.4459 103.919 31.8759 103.919 33.8129C103.919 35.7499 102.615 37.1409 100.959 37.1409ZM132.744 22.7369H126.916V38.9869H129.354V32.8249H132.757C135.455 32.8249 138.102 30.8749 138.102 27.7809C138.102 24.6869 135.455 22.7369 132.757 22.7369H132.744ZM132.809 30.5759H129.354V24.9989H132.809C134.634 24.9989 135.664 26.5069 135.664 27.7809C135.664 29.0549 134.634 30.5629 132.809 30.5629V30.5759ZM147.841 28.2359C146.081 28.2359 144.255 29.0159 143.499 30.7189L145.663 31.6159C146.12 30.7189 146.98 30.4199 147.88 30.4199C149.131 30.4199 150.422 31.1739 150.435 32.5129V32.6819C149.992 32.4349 149.053 32.0579 147.893 32.0579C145.559 32.0579 143.199 33.3319 143.199 35.7109C143.199 37.8819 145.103 39.2859 147.241 39.2859C148.87 39.2859 149.783 38.5579 150.344 37.6999H150.422V38.9609H152.769V32.7339C152.769 29.8479 150.604 28.2359 147.814 28.2359H147.841ZM147.541 37.1409C146.745 37.1409 145.637 36.7379 145.637 35.7629C145.637 34.5149 147.019 34.0339 148.219 34.0339C149.288 34.0339 149.796 34.2679 150.435 34.5799C150.252 36.0879 148.949 37.1539 147.541 37.1539V37.1409ZM161.334 28.5869L158.544 35.6329H158.466L155.572 28.5869H152.951L157.292 38.4409L154.815 43.9139H157.358L164.046 28.5869H161.347H161.334ZM139.419 38.9869H141.857V22.7369H139.419V38.9869Z'
          fill='#6C63FF'
        />
        <path
          d='M13.6104 9.80194C13.2324 10.2049 13.0107 10.8289 13.0107 11.6219V40.3779C13.0107 41.1839 13.2324 41.8079 13.6104 42.1979L13.7017 42.2889L29.8546 26.1819V25.8049L13.7017 9.71094L13.6104 9.80194Z'
          fill='url(#paint0_linear_228_15353)'
        />
        <path
          d='M35.2388 31.5637L29.8545 26.1947V25.8177L35.2388 20.4487L35.3561 20.5137L41.7312 24.1277C43.5564 25.1547 43.5564 26.8447 41.7312 27.8847L35.3561 31.4987L35.2388 31.5637Z'
          fill='url(#paint1_linear_228_15353)'
        />
        <path
          d='M35.3552 31.486L29.8535 26L13.6094 42.198C14.2091 42.835 15.1999 42.913 16.3211 42.276L35.3682 31.486'
          fill='url(#paint2_linear_228_15353)'
        />
        <path
          d='M35.3555 20.5137L16.3084 9.72374C15.1872 9.08674 14.1964 9.16474 13.5967 9.80174L29.8408 25.9997L35.3425 20.5137H35.3555Z'
          fill='url(#paint3_linear_228_15353)'
        />
        <path
          opacity='0.2'
          d='M35.2378 31.3687L16.308 42.0937C15.252 42.6917 14.3003 42.6527 13.7006 42.1067L13.6094 42.1977L13.7006 42.2887C14.3134 42.8347 15.252 42.8737 16.308 42.2757L35.3552 31.4857L35.2378 31.3687Z'
          fill='#F9F9F9'
        />
        <path
          opacity='0.12'
          d='M13.6095 42.0158C13.2314 41.6128 13.0098 40.9888 13.0098 40.1958V40.3908C13.0098 41.1968 13.2314 41.8208 13.6095 42.2108L13.7007 42.1198L13.6095 42.0288V42.0158Z'
          fill='#F9F9F9'
        />
        <path
          opacity='0.12'
          d='M41.7311 27.69L35.2256 31.369L35.3429 31.486L41.718 27.872C42.6306 27.352 43.0869 26.676 43.0869 26C43.0087 26.611 42.5524 27.222 41.718 27.69H41.7311Z'
          fill='#F9F9F9'
        />
        <path
          opacity='0.25'
          d='M16.3085 9.90567L41.7307 24.3097C42.552 24.7777 43.0214 25.3757 43.0996 25.9997C43.0996 25.3237 42.6433 24.6347 41.7307 24.1277L16.3085 9.72367C14.4833 8.69667 12.9971 9.55467 12.9971 11.6347V11.8297C12.9971 9.74967 14.4833 8.89167 16.3085 9.91867V9.90567Z'
          fill='#6C63FF'
        />
        <path
          d='M54.3652 12.4279C54.8606 12.3499 55.4473 12.2979 56.0861 12.2979C57.2464 12.2979 58.0678 12.5709 58.6283 13.0779C59.1889 13.5849 59.5149 14.3129 59.5149 15.3139C59.5149 16.3149 59.202 17.1729 58.6153 17.7449C58.0286 18.3299 57.0639 18.6419 55.8515 18.6419C55.2778 18.6419 54.7955 18.6159 54.3783 18.5639V12.4279H54.3652ZM55.1735 17.9529C55.3821 17.9919 55.6689 18.0049 55.9949 18.0049C57.7288 18.0049 58.6544 17.0429 58.6544 15.3529C58.6544 13.8839 57.8331 12.9479 56.1122 12.9479C55.695 12.9479 55.3821 12.9869 55.1605 13.0259V17.9529H55.1735Z'
          fill='#6C63FF'
        />
        <path
          d='M61.3669 12.3501V18.5901H60.5586V12.3501H61.3669Z'
          fill='#6C63FF'
        />
        <path
          d='M62.6572 17.6148C63.0222 17.8358 63.5437 18.0178 64.1043 18.0178C64.9256 18.0178 65.408 17.5888 65.408 16.9518C65.408 16.3668 65.069 16.0288 64.2216 15.7168C63.2047 15.3528 62.5659 14.8328 62.5659 13.9488C62.5659 12.9738 63.3742 12.2588 64.5867 12.2588C65.2255 12.2588 65.6948 12.4018 65.9686 12.5578L65.747 13.2208C65.5384 13.1038 65.1212 12.9218 64.5606 12.9218C63.7001 12.9218 63.3873 13.4288 63.3873 13.8578C63.3873 14.4428 63.7653 14.7288 64.6258 15.0668C65.6818 15.4698 66.2293 15.9898 66.2293 16.8998C66.2293 17.8618 65.5123 18.6938 64.0391 18.6938C63.4394 18.6938 62.7745 18.5118 62.4355 18.2908L62.6441 17.6148H62.6572Z'
          fill='#6C63FF'
        />
        <path
          d='M67.3506 12.428C67.7417 12.363 68.2501 12.311 68.902 12.311C69.6973 12.311 70.2839 12.493 70.662 12.831C71.001 13.13 71.2095 13.585 71.2095 14.131C71.2095 14.677 71.0401 15.145 70.7272 15.47C70.297 15.925 69.606 16.159 68.8107 16.159C68.563 16.159 68.3414 16.159 68.1589 16.107V18.603H67.3506V12.428ZM68.1589 15.444C68.3414 15.496 68.563 15.509 68.8238 15.509C69.8016 15.509 70.3882 15.041 70.3882 14.17C70.3882 13.299 69.8015 12.948 68.915 12.948C68.563 12.948 68.2893 12.974 68.1589 13.013V15.444Z'
          fill='#6C63FF'
        />
        <path
          d='M77.6354 15.4051C77.6354 17.5501 76.3317 18.6941 74.7281 18.6941C73.1246 18.6941 71.9121 17.4201 71.9121 15.5221C71.9121 13.5331 73.1506 12.2461 74.8194 12.2461C76.4881 12.2461 77.6354 13.5461 77.6354 15.4051ZM72.7726 15.5091C72.7726 16.8481 73.5026 18.0441 74.7672 18.0441C76.0318 18.0441 76.7749 16.8611 76.7749 15.4441C76.7749 14.1961 76.1231 12.9091 74.7803 12.9091C73.4374 12.9091 72.7726 14.1441 72.7726 15.5091Z'
          fill='#6C63FF'
        />
        <path
          d='M78.6918 18.5901V12.3501H79.5783L81.586 15.5091C82.0553 16.2371 82.4073 16.9001 82.7072 17.5371H82.7202C82.642 16.6921 82.6289 15.9381 82.6289 14.9631V12.3501H83.3851V18.5901H82.5638L80.5691 15.4181C80.1389 14.7291 79.7086 14.0141 79.3958 13.3381H79.3697C79.4218 14.1311 79.4349 14.8851 79.4349 15.9251V18.5901H78.6787H78.6918Z'
          fill='#6C63FF'
        />
        <path
          d='M86.5671 10.9331L85.3807 12.0121H84.7158L85.5763 10.9331H86.5671ZM85.6154 12.3501V18.5901H84.8071V12.3501H85.6154Z'
          fill='#6C63FF'
        />
        <path
          d='M88.3925 18.5901L86.3457 12.3501H87.2192L88.197 15.4311C88.4707 16.2761 88.6924 17.0301 88.8619 17.7711H88.8749C89.0574 17.0431 89.3051 16.2631 89.5919 15.4441L90.6479 12.3631H91.5084L89.266 18.6031H88.3795L88.3925 18.5901Z'
          fill='#6C63FF'
        />
        <path
          d='M95.4435 15.6651H93.0056V17.9141H95.7173V18.5901H92.1973V12.3501H95.5739V13.0261H93.0056V15.0021H95.4435V15.6651Z'
          fill='#6C63FF'
        />
        <path
          d='M96.7607 12.3501H97.569V17.9141H100.242V18.5901H96.7607V12.3501Z'
          fill='#6C63FF'
        />
        <path
          d='M106.356 15.6651H103.918V17.9141H106.629V18.5901H103.109V12.3501H106.486V13.0261H103.918V15.0021H106.356V15.6651Z'
          fill='#6C63FF'
        />
        <path
          d='M112.965 15.8469C112.913 14.9759 112.861 13.9359 112.874 13.1559H112.848C112.639 13.8839 112.378 14.6639 112.053 15.5219L110.944 18.5509H110.332L109.315 15.5739C109.015 14.6899 108.767 13.8839 108.585 13.1429H108.572C108.559 13.9229 108.506 14.9629 108.454 15.8989L108.285 18.5769H107.516L107.946 12.3369H108.976L110.045 15.3529C110.306 16.1199 110.514 16.8089 110.671 17.4589H110.697C110.853 16.8349 111.075 16.1459 111.362 15.3529L112.483 12.3369H113.513L113.904 18.5769H113.109L112.952 15.8339L112.965 15.8469Z'
          fill='#6C63FF'
        />
        <defs>
          <linearGradient
            id='paint0_linear_228_15353'
            x1='28.4205'
            y1='11.3229'
            x2='6.60661'
            y2='33.199'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#00A1FF' />
            <stop offset='0.26' stop-color='#00BEFF' />
            <stop offset='0.51' stop-color='#00D2FF' />
            <stop offset='0.76' stop-color='#00DFFF' />
            <stop offset='1' stop-color='#00E3FF' />
          </linearGradient>
          <linearGradient
            id='paint1_linear_228_15353'
            x1='44.104'
            y1='25.9997'
            x2='12.5674'
            y2='25.9997'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#FFE000' />
            <stop offset='0.41' stop-color='#FFBD00' />
            <stop offset='0.78' stop-color='#FFA500' />
            <stop offset='1' stop-color='#FF9C00' />
          </linearGradient>
          <linearGradient
            id='paint2_linear_228_15353'
            x1='32.3697'
            y1='28.99'
            x2='2.78175'
            y2='58.6492'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#FF3A44' />
            <stop offset='1' stop-color='#C31162' />
          </linearGradient>
          <linearGradient
            id='paint3_linear_228_15353'
            x1='9.51609'
            y1='0.23374'
            x2='22.724'
            y2='13.4793'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#32A071' />
            <stop offset='0.07' stop-color='#2DA771' />
            <stop offset='0.48' stop-color='#15CF74' />
            <stop offset='0.8' stop-color='#06E775' />
            <stop offset='1' stop-color='#00F076' />
          </linearGradient>
        </defs>
      </svg>
    </a>
  )
}

export default GooglePlayStoreIcon
